import React, { useEffect, useState } from 'react';
import { View, GridColumn, colors } from '@fairygodboss/ui';
import { ConvincerButton } from '../../../SharedComponents/ContentBody/Convincer';
import '../../../SharedComponents/ContentBody/froala_style.scss';
import { AuthWrapper } from '../../../../../../pages/HomePage_v2/sections/components/AuthWrapper';
import { EmitMetric } from '../../../../../Analytics/VisibilityPixel/VisibilityPixel';
import { useCommunityContent } from '../../CommunityPostContentContext';
import PostBoxContainer from '../../../../../UnifiedPostBox/PostBoxContainer/PostBoxContainer';

const CTAButton = ({ windowWidth }) => {
    const { type } = useCommunityContent();
    const [hasCookieBanner, setHasCookieBanner] = useState(false);
    const [xsButtonBottomPosition, setXsButtonBottomPosition] = useState(
        '16px'
    );

    useEffect(() => {
        if (hasCookieBanner) {
            setXsButtonBottomPosition('144px');
            return;
        }
        if (hasCookieBanner) {
            setXsButtonBottomPosition('144px');
        }
    }, [hasCookieBanner]);

    useEffect(() => {
        setTimeout(() => {
            const _cookieBannerEl = document.getElementById('cookie-banner');
            if (_cookieBannerEl) {
                setHasCookieBanner(true);
            }
        }, [100]);
    }, [type]);

    const onEmitMetirc = () => {
        EmitMetric({
            misc_event_type: 'single',
            misc_event_count: 1,
        });
    };

    return (
        <View
            position="fixed"
            right={{ _: '0px', sm: '24px' }}
            justifyContent={{ _: 'center', sm: 'end' }}
            width="100%"
            bottom={{
                _: xsButtonBottomPosition,
                sm: hasCookieBanner ? '88px' : '16px',
            }}
            zIndex="3"
            display={{ _: '-webkit-box', md: 'none' }}
        >
            <AuthWrapper
                component={
                    <ConvincerButton
                        onConvincerClick={onEmitMetirc}
                        text="Join the community"
                        windowWidth={windowWidth}
                    />
                }
                redirectUrl="/community/feed"
                loginTrigger="community-discussion-register"
            />
        </View>
    );
};

export const MainArticleBody = () => {
    const {
        contentBody,
        windowWidth,
        isLoggedIn,
        hash,
        content,
        editMode,
        handleOnEditCanceled,
        isCommunityDiscussionType,
    } = useCommunityContent();
    return (
        <View display="flex" justifyContent="space-between">
            {!isLoggedIn() ? <CTAButton windowWidth={windowWidth} /> : null}{' '}
            {editMode ? (
                <>
                    <GridColumn
                        size={{ xs: 12, sm: 12, md: 7.8, lg: 7.6 }}
                        className="fr-view"
                        pt={{ _: '24px', sm: '32px' }}
                        css={{
                            paddingLeft: '0px',
                            paddingRight: '0px',
                        }}
                    >
                        <PostBoxContainer
                            {...content}
                            editMode
                            handleOnEditCanceled={handleOnEditCanceled}
                            hash={hash}
                        >
                            {' '}
                        </PostBoxContainer>
                    </GridColumn>
                </>
            ) : (
                <>
                    <GridColumn
                        size={{ xs: 12, sm: 12, md: 7.8, lg: 7.6 }}
                        className="fr-view"
                        pt={{ _: '24px', sm: '32px' }}
                        css={{
                            paddingLeft: '0px',
                            paddingRight: '0px',
                        }}
                    >
                        <View
                            css={{
                                a: {
                                    textDecoration: 'underline !important',
                                    ':visited': {
                                        color: `${colors.secondary[70]} !important`,
                                    },
                                },
                                color: `${colors.neutral[100]} !important`,
                                fontSize: '18px',
                                p: {
                                    minHeight: '24px',
                                },
                                whiteSpace: 'pre-line',
                            }}
                            {...(isCommunityDiscussionType && {
                                itemProp: 'text',
                            })}
                        >
                            {contentBody}
                        </View>
                    </GridColumn>
                    <GridColumn
                        size={{
                            xs: 0,
                            sm: 0,
                            md: windowWidth > 1054 ? 3 : 4.0,
                            lg: 3.05,
                        }}
                        display={{ _: 'none', md: 'block' }}
                        pr={{ _: '0px', md: '24px', lg: '0px' }}
                        css={{
                            paddingLeft: '0px',
                        }}
                    />
                </>
            )}
        </View>
    );
};

MainArticleBody.displayName = 'MainArticleBody';
